<template>
  <div class="form-check">
    <Field
      class="form-check-input"
      :id="id"
      type="radio"
      :value="values"
      :name="field"
      required
      v-model="selectedValue"
      @change="selection"
      v-on="validationListeners"
      :disabled="disabled"
      :default="default"
      :defaultValue="defaultValue"
    />
    <p
      v-if="!backend"
      :class="labelClass"
      style="margin-bottom: 0; margin-left: 5px"
    >
      {{ label }}
    </p>
    <p
      v-else-if="backend"
      :class="labelClass"
      style="margin-bottom: 0; margin-left: 5px"
    >
      {{ label }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { Field, useField } from "vee-validate";

const emit = defineEmits(["selected"]);

const props = defineProps({
  label: String,
  values: String,
  id: {
    type: String,
    required: true,
  },
  selectedValue: {
    type: String,
    required: true,
  },
  field: {
    type: String,
    required: true,
  },
  validateRule: {
    type: String,
  },
  validationType: {
    type: String,
    default: "",
  },
  labelClass: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  backend: {
    type: Boolean,
    default: false,
  },
  default: {
    type: Boolean,
    default: false,
  },
  defaultValue: {
    type: String,
  },
});

const selectedValue = ref(props.selectedValue) || "";
const { value, errorMessage, handleBlur } = useField(
  () => props.field,
  props.validateRule,
  {
    validateOnValueUpdate: false,
  }
);

const selection = () => {
  emit("selected", selectedValue.value);
};

const validationListeners = {
  blur: (evt: Event | undefined) => handleBlur(evt, true),
};

watch(selectedValue, (newValue) => {
  value.value = newValue;
});

watch(
  [() => props.default, () => props.defaultValue],
  ([value1, value2], [prevResend, prevNumber]) => {
    if (value1 == true) {
      if (value2) {
        value.value = props.defaultValue;
        emit("selected", props.defaultValue);
      }
    } else if (value1 == false) {
      value.value = "";
      emit("selected", "");
    }
  }
);
</script>

<style scoped>
.value {
  margin-left: 8px;
  margin-bottom: 0px;
}

.flex {
  display: flex;
}

.form-check {
  margin-bottom: 10px;
}

.form-check-input {
  margin-top: -0.1px;
  width: 20px;
  height: 20px;
  border-color: #ac2887;
  box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  display: flex;
}

.form-check-input:checked::before {
  display: flex;
  width: 18px;
  height: 24px;
  font-size: 12px;
  content: url("@/svg/btn_select_selected.svg");
  position: absolute;
  align-items: center;
  justify-content: center;
  font-family: "sans-serif";
}

.form-check-input:focus {
  outline: none;
}

/*HRC Questionnaire*/
.radioLabel {
  color: rgba(0, 0, 0, 0.38);
  font: 500 16px/130% "Outfit", sans-serif;
}
</style>
